import request from "@/utils/request";
import { ENABLE_API_DBG } from "@/appConfig.js";

function addSubs(params) {
  ENABLE_API_DBG &&
    console.log(`api.groupSubs.addSubs: params = ${JSON.stringify(params)}`);
  return request({
    url: `/group-subscription`,
    method: "post",
    data: params,
  });
}

function removeSubs(itemId) {
  return request({
    url: `/group-subscription/${itemId}`,
    method: "delete",
  });
}

function setApprNeed(itemId, params) {
  return request({
    url: `/group-subscription/${itemId}`,
    method: "patch",
    data: params,
  });
}

export default {
  addSubs,
  removeSubs,
  setApprNeed,
};
